export default {
  id: 7,
  type: "logs",
  title: "Historial",
  deleteEntriesAllowed: false,
  adminOnly: true,
  actions: {
    get: "getLogs",
    post: "postTeacher",
    patch: "patchTeacher",
    delete: "deleteTeacher",
  },
  headers: [
    {
      title: "Fecha",
      field: {
        name: "created_at",
        type: "date",
      },
    },
    {
      title: "TIC",
      field: {
        name: "tic",
        type: null,
      },
    },
    {
      title: "Nombre TIC",
      field: {
        name: "tic_name",
        type: null,
      },
    },
    {
      title: "Acción",
      field: {
        name: "change_type",
        type: null,
      },
    },
    {
      title: "Registro",
      field: {
        name: "record_type",
        type: null,
      },
    },
    {
      title: "Nombre Registro",
      field: {
        name: "record_name",
        type: null,
      },
    },
    {
      title: "Cambios",
      field: {
        name: "changes",
        type: null,
      },
    },
  ],
  options: [],
  filters: [
    {
      title: "Fecha desde",
      name: "date_from",
      type: "date",
    },
    {
      title: "Fecha hasta",
      name: "date_to",
      type: "date",
    },
  ],
};
